export const IFRAME_SEARCH_PARAM_KEYS = {
  FULL3D: 'full3d',
  KIDS_MODE: 'kids_mode',
  CONTROL_BAR: 'control_bar',
  NO_COOKIE: 'no-cookie',
  NO_SCROLLLOCK: 'no-scrolllock',
  VIEW: 'view',
  IS_3D_COMMERCE: '3dcommerce',
  PREVIEW: 'preview',
  VERSION: 'version',
  TOKEN: 'token',
  RANDOM_CODE: 'random_code',
  VRAM_LIMIT_PASSED: 'vram_limit_passed',
  AD_SDK_DEBUG: 'ad-sdk-debug',
  VIDEO_DEBUG: 'debug',
  FORCE_LANDSCAPE_IOS: 'force_landscape_ios',
  TRANSPARENT: 'transparent',
} as const

export type IframeSearchParamKeys =
  (typeof IFRAME_SEARCH_PARAM_KEYS)[keyof typeof IFRAME_SEARCH_PARAM_KEYS]

export const INTERNAL_MESSAGE_PREFIXES = [
  'VIVERSE_SDK/',
  'VIVERSE_BRIDGE/',
  'VIVERSE_BRIDGE',
  'VIVERSE_APP/',
  'VIVERSE_VIDEO/',
  'VIVERSE_AD_SDK/',
] as const

export const isInternalMessage = (method: unknown): boolean => {
  if (typeof method !== 'string' || !method) return false
  return INTERNAL_MESSAGE_PREFIXES.some((prefix) => method.startsWith(prefix))
}
